import { useClerk } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/sso-callback")({
	component: SsoCallbackPage,
});

function SsoCallbackPage() {
	const { handleRedirectCallback } = useClerk();

	useEffect(() => {
		void handleRedirectCallback({
			afterSignInUrl: "/",
			afterSignUpUrl: "/",
		});
	}, [handleRedirectCallback]);

	return (
		<div className="flex min-h-[60vh] items-center justify-center">
			<div className="flex flex-col items-center gap-3">
				<div className="size-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
				<p className="text-sm text-muted-foreground">Completing sign in…</p>
			</div>
		</div>
	);
}
